import React from 'react';
import { PrimaryButton, DefaultButton, Panel, PanelType } from '../../fluent';
import { CodeEditor } from './CodeEditor';
export class JsonEditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: props.code || '',
            show: props.show || false,
            title: props.title || 'JSON'
        };
    }
    componentWillReceiveProps(props) {
        this.setState({
            code: props.code || '',
            show: props.show || false,
            title: props.title || 'JSON'
        });
    }
    render() {
        return React.createElement(Panel, { isOpen: this.state.show, type: PanelType.large, headerText: this.state.title, hasCloseButton: false, isFooterAtBottom: true, onRenderFooterContent: () => React.createElement("div", null,
                React.createElement("div", { className: 'ms-Grid-row' },
                    React.createElement("div", { className: 'ms-Grid-col ms-u-sm12', style: { textAlign: 'right' } },
                        React.createElement(PrimaryButton, { text: 'Aceptar', primary: true, onClick: () => {
                                let newProps = undefined;
                                try {
                                    newProps = JSON.parse(this.state.code);
                                }
                                catch (error) {
                                    if (this.props.onValidationError) {
                                        this.props.onValidationError();
                                    }
                                    return;
                                }
                                this.props.onAccept(JSON.stringify(newProps, undefined, 2));
                                this.props.onClose();
                            } }),
                        React.createElement("span", null, "\u00A0\u00A0"),
                        React.createElement(DefaultButton, { text: 'Volver', primary: false, onClick: () => this.props.onClose() })))), closeButtonAriaLabel: 'Cerrar' },
            React.createElement(CodeEditor, { value: this.state.code || '', onChanged: json => {
                    this.setState({
                        code: json
                    }, () => this.props.onChange(this.state.code));
                }, language: 'json' }));
    }
}
